import React, { useEffect, useState } from 'react';
import { Image } from 'react-bootstrap';
import { getUserProfileUrl } from '../../utils/camp.utils';
import { Box, Typography } from '@mui/material';
import GuardianCamps from '../views/camp_schedule/GuardianCamps';
import './binkiesCompliments.css';
import ViewNoteModal from '../views/school/ViewNoteModal';
import ReplySuccessModal from '../views/school/ReplySuccessModal';
import Lock from '../../assets/images/Lock.svg';
import { useHistory } from 'react-router-dom';
import { PAYMENT_ROUTE } from '../../constants/routes.constants';
import { useAuth } from '../auth/Auth';

const CalendarRightSection = ({
  dependent,
  selectedDate,
  highlightedDays,
  highlightedFeelingDays,
  highlightedNotesDays,
  highlightedDaysData,
  highlightedDaysFeelingData,
  highlightedDaysNotesData,
  getMoodReasonComment,
  avatarClass,
  selectedEvent,
  getDependentNotes,
  mood,
  isPromiseLoading,
  twentyMinPromise,
}) => {
  const [showViewNoteModal, setShowViewNoteModal] = useState(false);
  const [showReplySuccessModal, setShowReplySuccessModal] = useState(false);
  const [viewNoteText, setViewNoteText] = useState(null);
  const history = useHistory();
  const { guardian } = useAuth();

  const convertDate = (data) => {
    const date = new Date(data);
    return date;
  };

  const truncateText = (text, maxLength) => {
    if (text) {
      if (text?.length <= maxLength) return text;
      return text.substring(0, maxLength) + '...';
    } else {
      return text;
    }
  };

  const handleViewNoteClick = (text) => {
    setViewNoteText(text);
    setShowViewNoteModal(true);
  };

  const handleUpgradeClick = () => {
    history.push({
      pathname: `${PAYMENT_ROUTE}`,
      state: {
        dependent: JSON.stringify(dependent),
        type: dependent?.profile?.is_activated ? 'edit' : 'activate',
      },
    });
  };

  const getData = () => {
    switch (selectedEvent) {
      case 1:
        return (
          <div className="calendar-right-section-wrapper">
            <Box
              className="thoughts-box-div calendar-main"
              style={{ position: 'relative', top: '-80px' }}
              mt={3}
              display="flex"
              alignItems="center"
            >
              <Box className="thoughts-box" ml={2}>
                {mood === 'All' ? (
                  ''
                ) : (
                  <Typography
                    variant="h6"
                    gutterBottom
                    className={`i-am-section ${mood}`}
                  >
                    <img
                      src={getUserProfileUrl(dependent)}
                      alt="Comment Icon"
                      style={{ borderRadius: '100%' }}
                    />{' '}
                    I am...
                    <span className="mood-thought">
                      {' '}
                      {mood.charAt(0).toUpperCase() + mood.slice(1)}
                    </span>
                  </Typography>
                )}
              </Box>
            </Box>
            <div
              className={`kid-background-container kid-background-container-bg ${avatarClass}`}
            >
              <Image
                className="kid-background-image"
                src={getUserProfileUrl(dependent)}
              />
            </div>
            {selectedDate && highlightedFeelingDays.includes(selectedDate) ? (
              <Typography variant="body1" className="text-mood">
                "I'm{' '}
                <span
                  className={`mood-today-${
                    highlightedDaysFeelingData[
                      highlightedDaysFeelingData.findIndex(
                        (item) => Number(item.day) === selectedDate
                      )
                    ]?.mood
                  }`}
                >
                  {
                    highlightedDaysFeelingData[
                      highlightedDaysFeelingData.findIndex(
                        (item) => Number(item.day) === selectedDate
                      )
                    ]?.mood
                  }
                </span>{' '}
                today because {getMoodReasonComment()}"
              </Typography>
            ) : (
              <Typography variant="body1" className="text-mood">
                Choose one of the moods to discover more details about{' '}
                {dependent?.first_name}.
              </Typography>
            )}
          </div>
        );
      case 2:
        return <GuardianCamps dependent={dependent} type="Creative" />;
      case 3:
        return (
          <GuardianCamps
            selectedDate={selectedDate}
            dependent={dependent}
            type="Special"
          />
        );
      case 4:
        if (guardian) {
          if (
            dependent?.subscriptions?.nickname === 'Villagers' ||
            dependent?.subscriptions?.nickname === 'Branches'
          ) {
            return (
              <div className="calendar-right-section-wrapper">
                {showViewNoteModal && (
                  <ViewNoteModal
                    isCampConnected={
                      dependent?.profile?.group?.id ? true : false
                    }
                    text={viewNoteText}
                    showModal={showViewNoteModal}
                    setShowModal={setShowViewNoteModal}
                    setShowReplySuccessModal={setShowReplySuccessModal}
                  />
                )}
                {showReplySuccessModal && (
                  <ReplySuccessModal
                    showModal={showReplySuccessModal}
                    setShowModal={setShowReplySuccessModal}
                    getDependentNotes={getDependentNotes}
                  />
                )}
                <div
                  className={`kid-background-container kid-background-container-bg notes`}
                >
                  <Image
                    className="kid-background-image"
                    src={getUserProfileUrl(dependent)}
                  />
                </div>
                {selectedDate && highlightedNotesDays.includes(selectedDate) ? (
                  <Typography variant="body1" className="text-mood">
                    Your Camp Captain:{' '}
                    <span className="camp-captain-name-span">
                      {
                        highlightedDaysNotesData[
                          highlightedDaysNotesData.findIndex(
                            (item) =>
                              convertDate(item.created_at).getDate() ===
                              selectedDate
                          )
                        ]?.sender?.first_name
                      }
                    </span>
                    <br />
                    <span
                      className="calendar-notes-text"
                      onClick={() =>
                        handleViewNoteClick(
                          highlightedDaysNotesData[
                            highlightedDaysNotesData.findIndex(
                              (item) =>
                                convertDate(item.created_at).getDate() ===
                                selectedDate
                            )
                          ]
                        )
                      }
                    >
                      {truncateText(
                        highlightedDaysNotesData[
                          highlightedDaysNotesData.findIndex(
                            (item) =>
                              convertDate(item.created_at).getDate() ===
                              selectedDate
                          )
                        ]?.content,
                        120
                      )}
                    </span>
                  </Typography>
                ) : (
                  <Typography variant="body1" className="text-mood">
                    Choose one of the date to discover more details about{' '}
                    {dependent?.first_name}.
                  </Typography>
                )}
              </div>
            );
          } else {
            return (
              <div
                className="calendar-right-section-wrapper"
                style={{ width: '50%' }}
              >
                <div
                  className="insights-img"
                  style={{ paddingTop: 0, paddingBottom: '5px' }}
                >
                  <img className="" src={Lock} alt="Lock icon" />
                  {guardian && (
                    <>
                      <h4>
                        Unlock{' '}
                        <span className="insights-span">
                          {' '}
                          Camp Captain Notes{' '}
                        </span>
                        <br />
                        to see your kids progress.
                      </h4>
                      <button
                        className="subscription-button Upgrade gred-btn"
                        onClick={handleUpgradeClick}
                      >
                        Upgrade to Villagers
                      </button>
                    </>
                  )}
                </div>
              </div>
            );
          }
        } else {
          return (
            <div className="calendar-right-section-wrapper">
              {showViewNoteModal && (
                <ViewNoteModal
                  text={viewNoteText}
                  showModal={showViewNoteModal}
                  setShowModal={setShowViewNoteModal}
                  setShowReplySuccessModal={setShowReplySuccessModal}
                />
              )}
              {showReplySuccessModal && (
                <ReplySuccessModal
                  showModal={showReplySuccessModal}
                  setShowModal={setShowReplySuccessModal}
                  getDependentNotes={getDependentNotes}
                />
              )}
              <div
                className={`kid-background-container kid-background-container-bg notes`}
              >
                <Image
                  className="kid-background-image"
                  src={getUserProfileUrl(dependent)}
                />
              </div>
              {selectedDate && highlightedNotesDays.includes(selectedDate) ? (
                <Typography variant="body1" className="text-mood">
                  Your Camp Captain:{' '}
                  <span className="camp-captain-name-span">
                    {
                      highlightedDaysNotesData[
                        highlightedDaysNotesData.findIndex(
                          (item) =>
                            convertDate(item.created_at).getDate() ===
                            selectedDate
                        )
                      ]?.sender?.first_name
                    }
                  </span>
                  <br />
                  <span
                    className="calendar-notes-text"
                    onClick={() =>
                      handleViewNoteClick(
                        highlightedDaysNotesData[
                          highlightedDaysNotesData.findIndex(
                            (item) =>
                              convertDate(item.created_at).getDate() ===
                              selectedDate
                          )
                        ]
                      )
                    }
                  >
                    {truncateText(
                      highlightedDaysNotesData[
                        highlightedDaysNotesData.findIndex(
                          (item) =>
                            convertDate(item.created_at).getDate() ===
                            selectedDate
                        )
                      ]?.content,
                      120
                    )}
                  </span>
                </Typography>
              ) : (
                <Typography variant="body1" className="text-mood">
                  Choose one of the date to discover more details about{' '}
                  {dependent?.first_name}.
                </Typography>
              )}
            </div>
          );
        }

      case 5:
        return (
          <GuardianCamps
            dependent={dependent}
            type="Promise"
            isPromiseLoading={isPromiseLoading}
            twentyMinPromise={twentyMinPromise}
          />
        );
      default:
        return '';
    }
  };

  return getData();
};

export default CalendarRightSection;
